module.exports = __webpack_public_path__ + "assets/requirejs.9af81f07.svg";